export default __webpack_public_path__ + "fba93ae300eeb5130068d3a15514ab35.png";